import * as React from "react";
import {Link} from "react-router-dom";
import {ConversationsRoutes, FeedsRoutes, SearchRoutes, ShopsRoutes, SpecialsRoutes, StylesRoutes} from "../../routes";
import {Api} from "../../_helpers/api";
import LinkContainer from "../../_widgets/sidebarLink/LinkContainer";
import {Dispatch} from "react-redux";
import UserRedirectContainer from "../../_widgets/user/UserRedirectContainer";
import * as classNames from "classnames";
import User from "../../_data/models/User";

interface Props {
    dispatch: Dispatch<any>;
    unreadMessageCount: number;
    currentUser:User
}

const SidebarComponent = (props: Props) => {
    const {currentUser, unreadMessageCount} = props;
    let form: HTMLFormElement;
    const classes = classNames("off-canvas reveal-for-medium position-left", {"hidden": currentUser == null});

    return (
        <div className={classes} id="offCanvasLeft" data-off-canvas>
            <ul className="vertical dropdown menu dashboard-menu" data-dropdown-menu>
                <p className="dashboard-menu-text text-center">
                    <span className="logo">
                        <Link to={Api.baseUrl}>
                            <img src={window.Styleteq.images.logoWhite} alt="Styleteq Logo"/>
                        </Link>
                    </span>
                </p>
                {currentUser &&
                <li className="profile">
                    <UserRedirectContainer id={currentUser.id} element="a">
                        <img src={currentUser.profilePicture()} className="img-wrapper circle"/>
                        &nbsp;<span>{currentUser.username()}</span>
                        <small>View Profile</small>
                    </UserRedirectContainer>
                </li>
                }

                <LinkContainer to={FeedsRoutes.index()}>
                    <i className="fa fa-newspaper-o fa-fw"/> Activity
                </LinkContainer>

                <LinkContainer to={SearchRoutes.index()}>
                    <i className="fa fa-search fa-fw"/> Search
                </LinkContainer>

                {/*Account*/}
                <p className="dashboard-menu-title">ACCOUNT</p>
                <LinkContainer to={ConversationsRoutes.index()}>
                    <i className="fa fa-envelope-o fa-fw"/> My Messages
                    {unreadMessageCount > 0 &&
                    <span className="button__badge ml-1">{unreadMessageCount} New</span>
                    }
                </LinkContainer>

                {currentUser && currentUser.isProfessional &&
                <LinkContainer to={ShopsRoutes.index()}>
                    <i className="fa fa-scissors fa-fw"/> My Shops
                </LinkContainer>
                }


                <LinkContainer to={StylesRoutes.index()}>
                    <i className="fa fa-camera-retro fa-fw"/> My Images
                </LinkContainer>

                {currentUser && currentUser.isProfessional &&
                <LinkContainer to={SpecialsRoutes.index()}>
                    <i className="fa fa-star fa-fw"/> My Specials
                </LinkContainer>
                }

                {/*Settings*/}
                {/*<p className="dashboard-menu-title">Settings</p>*/}
                {/*<li>*/}
                {/*<a href=""><i className="fa fa-info-circle fa-fw"/> How To</a>*/}
                {/*</li>*/}
                {/*<li>*/}
                {/*<a href=""><i className="fa fa-file-text-o fa-fw"/> Terms of Service</a>*/}
                {/*</li>*/}
                {/*<li>*/}
                {/*<a href=""><i className="fa fa-user-plus fa-fw"/> Invite Users</a>*/}
                {/*</li>*/}

                {currentUser &&
                <li className="footer">
                    <a onClick={() => form.submit()}><i className="fa fa-sign-out fa-fw"></i> Sign Out</a>
                    <form action="/v1/users/sign_out" method="post" ref={(e) => form = e}>
                        <input type="hidden" name="_method" value="delete"/>
                    </form>
                </li>
                }
            </ul>
        </div>
    );
};

export default SidebarComponent;


// WEBPACK FOOTER //
// ./app/client/dashboard/components/SidebarComponent.tsx